import coverAsset from '@/assets/unbequem-gesund-cover.jpg.asset.json';

/** Real cover of "Unbequem Gesund" – used wherever the book cover appears. */
const BookCover = ({ className = '' }: { className?: string }) => (
  <img
    src={coverAsset.url}
    alt="Buchcover Unbequem Gesund von Jürgen Klanert, PhD"
    width={1234}
    height={1920}
    loading="lazy"
    decoding="async"
    className={`aspect-[1234/1920] w-full max-w-[300px] h-auto rounded-r-md rounded-l-sm shadow-premium ${className}`}
  />
);

export default BookCover;
